import { createSelector } from "reselect"
import { find, map, get } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { getFilteredData, getCategoryItems } from "./data"

export const getDetails = createSelector(
  [getFilteredData, getCategoryItems, getSelectedDate],
  (data, items, date) => {
    const datum = find(data, d => d.date.isSame(date))

    return map(items, item => ({
      ...item,
      value: get(datum, item.id),
    }),
    )
  },
)
